import { AvailableCurrency } from '../../translations/timezones';

const EUR = [
  'ALL',
  'BAM',
  'EUR',
  'BGN',
  'BYN',
  'CHE',
  'CHF',
  'CHW',
  'CZK',
  'DKK',
  'GIP',
  'HRK',
  'HUF',
  'ISK',
  'MDL',
  'MKD',
  'NOK',
  'PLN',
  'RON',
  'RSD',
  'RUB',
  'SEK',
  'UAH',
];

const GBP = ['GBP'];

export const mapCurrency = (currencyCode: string): AvailableCurrency => {
  if (GBP.some((code) => code === currencyCode)) {
    return AvailableCurrency.GBP;
  }

  if (EUR.some((code) => code === currencyCode)) {
    return AvailableCurrency.EUR;
  }

  return AvailableCurrency.USD;
};
